import { atom } from 'recoil'
import Lib from 'library'

export const searchState = atom({
	key: "searchState",
	default: {
		stDe: (() => Lib.dateFormat(new Date().setMonth(new Date().getMonth() - 1)))(),
		edDe: (() => Lib.dateFormat(new Date()))(),
		period: 1,
		type: "",
		industry: ""
	},
	effects: [
		({ onSet }) => onSet(prev => console.log(prev))
	]
})

export const showDetailLayerState = atom({
	key: "showDetailLayerState",
	default: {
		show: false,
		id: undefined
	}
})

export const receiptLayerState = atom({
	key: "receiptLayerState",
	default: false
})